/* eslint-disable */
import { Injectable, Output, EventEmitter } from '@angular/core';
import { AccountType } from '../models/Enum/AccountType';
import { Wheel } from '../models/Enum/Wheel';
import { MaritalStatus } from '../models/Enum/MaritalStatus';
import { TaxBracket } from '../models/Enum/TaxBracket';
import { EmploymentStatus } from '../models/Enum/EmploymentStatus';
import { AccountTypeFunding } from '../models/Enum/AccountTypeFunding';
import { BankAccountTypeFunding } from '../models/Enum/BankAccountTypeFunding';
import { NatureOfBusiness } from '../models/Enum/NatureOfBusiness';
import { Position } from '../models/Enum/Position';
import { SecurityQuestion } from '../models/Enum/SecurityQuestion';
import { PromoCode } from '../models/Enum/PromoCode';
import { tradingLevels } from '../models/Enum/tradingLevels';
import { cipWhitelist } from '../models/Enum/cipTesting';
import { Goal } from '../models/Enum/Goal';
import { Retirement } from '../models/Enum/Retirement';
import { RiskTolerance } from '../models/Enum/RiskTolerance';
import { TKARiskTolerance } from '../models/Enum/TKARiskTolerance';
import { StrategyType } from '../models/Enum/StrategyType';
import { BadWordsService } from './words.service';
import { ApplicationActions } from '../../actions/application.actions';
import { TimeService } from './time.service';
import { FlowManagerService } from './flowmanager.service';
import { SelectOptionsService } from './selectoptions.service';
import moment from 'moment';

@Injectable()
export class Validation {

  @Output() validationCheck = new EventEmitter();
  @Output() validateInput = new EventEmitter();

  constructor(
    appActions: ApplicationActions,
    timeService: TimeService,
    flowManager: FlowManagerService,
    selectOptions: SelectOptionsService,
    badWordsService: BadWordsService) {
    this.appActions = appActions;
    this.timeService = timeService;
    this.flowManager = flowManager;
    this.selectOptions = selectOptions;
    this.badWordsService = badWordsService;
    this.list = [
      '124303120',
      '073972181',
      '026009593',
      '124071889',
      '091017138',
      '041215663',
      '063192874',
      '063192971',
      '124085024',
      '021409169',
      '031101169',
      '114924742',
      '124303120',
      '061120000',
      '084003997',
      '073972181',
      '061120084',
      '124071889',
      '124085024',
      '124302529',
      '124303162',
      '062202985',
      '026014902',
      '101019084',
      '031101279'
    ];

    this.schema = this.flowManager.getValidationSchema();
    this.badWordsService.getBadWords().then(resp => {
      this.badWordsRegEx = resp.regEx;
      this.badWordsNamesRegEx = resp.namesRegEx; // Used for name fields to omit certain flagged words
    });
  }

  checkBadWords(value, isNameField = false) {
    const regEx = isNameField ? this.badWordsNamesRegEx : this.badWordsRegEx;
    if (regEx && value != null && value !== '') {
      const res = value.replace(/[\s_]+/g, ' ').replace(/^\s|\s$/g, '');
      const badWordMatches = res.match(regEx);
      if (badWordMatches) {
        return false;
      }
    }
    return true;
  }

  _isValidDateDob(str) {
    let d = moment(str,'MM/DD/YYYY');
    if(d == null || !d.isValid()) return false;
    return str.indexOf(d.format('MM/DD/YYYY')) >= 0
  }

  _isValidDateEmployedSince(str) {
    let d = moment(str,'MM/YYYY');
    if(d == null || !d.isValid()) return false;
    return str.indexOf(d.format('MM/YYYY')) >= 0
  }

  _isValidDateSignature(str) {
    return this._isValidDateDob(str) && (moment(str,'MM/DD/YYYY').format('MM/DD/YYYY') === (moment().format('MM/DD/YYYY')));
  }

  _inBlacklist(num) {
    if (_.indexOf(this.list, num) === -1) return false;
    return true;
  }

  _isValidRounting(num) {
    num = `${num}`;
    let n = 0;
    for (let i = 0; i < num.length; i += 3) {
      n += parseInt(num.charAt(i), 10) * 3;
      n += parseInt(num.charAt(i + 1), 10) * 7;
      n += parseInt(num.charAt(i + 2), 10);
    }
    return (n != 0 && n % 10 === 0);
  }

  isAllyRouting(num) {
    return num === '124003116';
  }

  validCheck(event) {
    this.validationCheck.emit(event);
  }

  validateForm() {
    // Trigger each element to validate iteself.
    // Elements are responsible for displaying their own errors as well as reporting up to the FormFactory
    this.validateInput.emit();
  }

  _validateSsn(key, value) {
    const primaryIndex = this.appActions.getData('BeneficiaryInformation.PrimaryIndex');
    const contingentIndex = this.appActions.getData('BeneficiaryInformation.ContingentIndex');

    let ssnPaths = [
      'BeneficiaryInformation.Primary[0].ssn',
      'BeneficiaryInformation.Primary[1].ssn',
      'BeneficiaryInformation.Primary[2].ssn',
      'BeneficiaryInformation.Primary[3].ssn',
      'BeneficiaryInformation.Contingent[0].ssn',
      'BeneficiaryInformation.Contingent[1].ssn',
      'BeneficiaryInformation.Contingent[2].ssn',
      'CustodialMinorInformation.ssn',
      'JointAccountInformation.ssn',
      'PersonalInformation.ssn'
    ];

    let idToDelete = null;
    if (key === 'ssn') idToDelete = 'PersonalInformation.ssn';
    if (key === 'beneficiary.ssn') idToDelete = 'BeneficiaryInformation.Primary[0].ssn';
    if (key.indexOf('joint') >= 0) idToDelete = 'JointAccountInformation.ssn';
    if (key.indexOf('minor') >= 0) idToDelete = 'CustodialMinorInformation.ssn';
    if (key.indexOf('primary') >= 0 && primaryIndex != null) idToDelete = `BeneficiaryInformation.Primary[${primaryIndex}].ssn`
    if (key.indexOf('contingent') >= 0 && contingentIndex != null) idToDelete = `BeneficiaryInformation.Contingent[${contingentIndex}].ssn`

    if (idToDelete !== null) delete ssnPaths[ssnPaths.indexOf(idToDelete)];

    ssnPaths = ssnPaths.filter(v => v != null);

    const ssnValues = ssnPaths.map(path => this.appActions.getData(path));

    return ssnValues.indexOf(value) === -1;
  }

  matchSpecialRule(specialRule) {
    const reduxValue = this.appActions.getData(specialRule.reduxPath);

    for (const rule of specialRule.rules) {
      // Is this DTC covered in this check
      if (rule.values.indexOf(reduxValue) >= 0) {
        return rule;
      }
    }

    // Use catch all because we havent hit value in the checks above
    return specialRule.catchAll;
  }

  displayMaxAmount(options) {
    const maxOneAllyAmt = {
      ira: { num: 7000, str: '$7,000' },
      ach: { num: 30000, str: '$30,000' },
      achTKA: { num: 150000, str: '$150,000' },
      ally: { num: 250000, str: '$250,000' }
    };
    let { num, str } = maxOneAllyAmt.ally;
    if (options.isIRA) {
      num = maxOneAllyAmt.ira.num;
      str = maxOneAllyAmt.ira.str;
    } else if (!options.isOneAlly && !options.isTKA) {
      num = maxOneAllyAmt.ach.num;
      str = maxOneAllyAmt.ach.str;
    } else if (!options.isOneAlly && options.isTKA) {
      num = maxOneAllyAmt.achTKA.num;
      str = maxOneAllyAmt.achTKA.str;
    }
    return { num, str };
  }

  validate(key, value) {
    try {
      let isValidObj = { state: true }
      // TODO: Change this part when we capture date
      let primaryFirstName = this.appActions.getData('YourInformation.firstName')? this.appActions.getData('YourInformation.firstName'): 'Account';
      let primaryLastName = this.appActions.getData('YourInformation.lastName')? this.appActions.getData('YourInformation.lastName'): 'Holders Name';
      let primaryMI = this.appActions.getData('YourInformation.middleInitial')? (this.appActions.getData('YourInformation.middleInitial')+' '): '';
      let primaryHolderName = `${primaryFirstName} ${primaryMI}${primaryLastName}`;
      let secondrayFirstName = this.appActions.getData('JointAccountInformation.firstName')? this.appActions.getData('JointAccountInformation.firstName'): 'Secondray Account';
      let secondrayLastName = this.appActions.getData('JointAccountInformation.lastName')? this.appActions.getData('JointAccountInformation.lastName'): 'Holders Name';
      let secondrayMI = this.appActions.getData('JointAccountInformation.middleInitial')? (this.appActions.getData('JointAccountInformation.middleInitial')+' '): '';
      let secondrayHolderName = `${secondrayFirstName} ${secondrayMI}${secondrayLastName}`;
      let appType = this.flowManager.getAppType() || 'tks';
      const employedCountry = this.appActions.getData('EmploymentInformation.employed.address.country');
      if (Object.keys(this.schema).length === 0) {
        this.schema = this.flowManager.getValidationSchema();
      }

      let rules = this.schema[key];

      if(key === 'employed.address.zip' || key === 'employed.address.state') {
        rules.require = employedCountry === 'US';
      }

      // Dynamic Redux based validation
      if(rules.reduxSpecial !== undefined) {
        const matchedRule = this.matchSpecialRule(rules.reduxSpecial);
        if(matchedRule) {
          rules = matchedRule;
        }
      }

      if (rules.require) {
        isValidObj.state = /([^\s])/.test(value);
        if (!isValidObj.state) {
          // TODO: remove signature validation rules (fields dont exist anymore)
          if(key === 'signatureDate' || key === 'jointSignatureDate') {
            isValidObj.msg = 'Please type ' + '\"' + moment().format('MM/DD/YYYY') + '\"' + '.';
            return isValidObj;
          }
          else if (key === 'signature') {
            if(value.toLowerCase() !== primaryHolderName.toLowerCase()) {
              isValidObj.msg = `Please type "${primaryHolderName}".`;
              return isValidObj;
            }
          }
          else if (key === 'jointSignature') {
            if (value.toLowerCase() !== secondrayHolderName.toLowerCase()) {
              isValidObj.msg = `Please type "${secondrayHolderName}".`;
              return isValidObj;
            }
          }
          else {
            isValidObj.msg = rules.messages.require;
            return isValidObj;
          }
        }
      }

      // File upload required
      if (key.toLowerCase().includes('document') && rules.require) {
        isValidObj = value && value.name ? { state: true } : { state: false, msg: rules.messages.require };
        if (!isValidObj.state) {
          return isValidObj;
        }
      }

      if (rules.pattern && value !== '') {
        isValidObj.state = eval(rules.pattern);
        if (!isValidObj.state) {
          if(key === 'signatureDate' || key === 'jointSignatureDate') {
            isValidObj.msg = 'Please type \"' + moment().format('MM/DD/YYYY') + '\".';
            return isValidObj;
          } else if(key === 'signature') {
            isValidObj.msg = `Please type "${primaryHolderName}".`;
            return isValidObj;
          } else if(key ==='jointSignature') {
            isValidObj.msg = `Please type "${secondrayHolderName}".`;
            return isValidObj;
          }
          else if (key === 'Credentials_Username') {
            if (/[^a-zA-Z_0-9@\-_.]/i.test(value)) {
              isValidObj.msg = rules.messages.special;
            } if(/\s/g.test(value)) {
              isValidObj.msg = rules.messages.space;
            } if (/\d{9}/.test(value)) {
              isValidObj.msg = rules.messages.patternConsecutiveNumbers;
            } if (/(.*\.\.)/.test(value)) {
              isValidObj.msg = rules.messages.periods;
            } else {
              isValidObj.msg = rules.messages.special;
            }
            return isValidObj;
          }
          // Need this in order to test CIP dummy data
          else if ((key === 'ssn' && this.flowManager.environment !== 'production') || (key === 'ssn' && window.location.origin.indexOf('tk.local' > -1))) {
            let fullSsn = value.replace(/\-/g, '');
            if (cipWhitelist.indexOf(fullSsn) > -1) {
              isValidObj.msg = '';
              isValidObj.state = true;
            } else {
              isValidObj.msg = rules.messages.pattern;
              isValidObj.state = false;
            }
            return isValidObj;
          } else {
            isValidObj.msg = rules.messages.pattern;
            return isValidObj;
          }
        } else if(key === 'Credentials_Password') {
          if(/\s/g.test(value)) {
            isValidObj.msg = rules.messages.space;
            isValidObj.state = false;
          }
        }
        else if(key === 'ssn' || key === 'ssnMinor' || key === 'beneficiary.ssn' || key === 'Primary_Beneficiary_Ssn' || key === 'Contingent_Beneficiary_Ssn' ||
          key === 'Joint_Personal_Ssn') {
          let fullSsn = value.replace(/\-/g,'');

          if(/^\b(\d)\1+$/.test(fullSsn)) {
            isValidObj.msg = rules.messages.pattern;
            isValidObj.state = false;
            return isValidObj;
          } else if(value === '123-45-6789') {
            isValidObj.msg = rules.messages.pattern;
            isValidObj.state = false;
            return isValidObj;
          }
        } else if ( key === 'mobilePhone' || key === 'otherPhone' || key === 'telephone' ||
          key === 'Joint_Employed_Telephone' || key === 'Joint_Personal_Other_Phone' ||
          key === 'Joint_Personal_Mobile_Phone') {
          let firstGroup = value.substring(0, 3);
          if (/^([0-9])\1*$/.test(firstGroup) || firstGroup[0] === '1' || firstGroup[0] === '0') {
            isValidObj.msg = rules.messages.pattern;
            isValidObj.state = false;
            return isValidObj;
          }
        } else if (key === 'address.street'
          || key === 'address.street2'
          || key === 'Joint_Mailing_Address_Street'
          || key === 'Joint_Mailing_Address_Street2') {
          if (/^(?!box[^a-z]|(p[-. ]*o.?[- ]*|post[ ]*office[ ]*)b(.|ox))/i.test(value) !== true) {
            isValidObj.msg = 'Please enter a street address (not a PO Box).';
            isValidObj.state = false;
            return isValidObj;
          }
        } else if(key === 'promoCode'){
          if(PromoCode.indexOf(value.toUpperCase()) <= -1) {
            isValidObj.msg = rules.messages.pattern;
            isValidObj.state = false;
            return isValidObj;
          }
        } else if(key === 'dob' || key === 'dobCustodial' || key === 'beneficiary.dob' || key === 'Primary_Beneficiary_Dob' ||
          key === 'Contingent_Beneficiary_Dob' || key === 'Joint_Personal_Dob' || key === 'deposit_date') {
          if(this._isValidDateDob(value) !== true){
            isValidObj.msg = rules.messages.pattern;
            isValidObj.state = false;
            return isValidObj;
          }
        } else if(key === 'employedSince' || key === 'Joint_Employed_Since') {
          let userYear = moment(value, "MM/YYYY").year();
          let diffYear = moment().year() - userYear;
          let userMonth = moment(value, "MM/YYYY").month();
          let diffMonth = moment().month() - userMonth;
          if(this._isValidDateEmployedSince(value) !== true) {
            isValidObj.msg = rules.messages.pattern;
            isValidObj.state = false;
            return isValidObj;
          }

          if (diffYear <0 || (diffYear ===0 && diffMonth <0)) {
            isValidObj.msg = rules.messages.minAge;
            isValidObj.state = false;
            return isValidObj;
          }

          if (userYear<1900) {
            isValidObj.msg = rules.messages.maxAge;
            isValidObj.state = false;
            return isValidObj;
          }
        } else if (key === 'signatureDate' || key === 'jointSignatureDate' ) {
            if(this._isValidDateSignature(value) !== true){
              isValidObj.msg = 'Please type ' + '\"' + moment().format('MM/DD/YYYY') + '\"' + '.';
              isValidObj.state = false;
              return isValidObj;
            }
          }
          else if (key === 'signature') {
            if(value.toLowerCase() !== primaryHolderName.toLowerCase()) {
              isValidObj.msg = `Please type "${primaryHolderName}".`;
              isValidObj.state = false;
              return isValidObj;
            }
          }
          else if (key === 'jointSignature') {
            if (value.toLowerCase() !== secondrayHolderName.toLowerCase()) {
              isValidObj.msg = `Please type "${secondrayHolderName}".`;
              isValidObj.state = false;
              return isValidObj;
            }
          }

          if (key === 'beneficiary.percent' || key === 'Primary_Beneficiary_Percent') {
            if (value<1) {
              isValidObj.msg = 'Percent is invalid. Enter a whole number between 1 and 100.';
              isValidObj.state = false;
              return isValidObj;
            }
            if (value>100) {
              isValidObj.msg = 'Primary Beneficiary cannot exceed 100%.';
              isValidObj.state = false;
              return isValidObj;
            }
          }

          if (key === 'Contingent_Beneficiary_Percent') {
            if (value<1) {
              isValidObj.msg = 'Percent is invalid. Enter a whole number between 1 and 100.';
              isValidObj.state = false;
              return isValidObj;
            }
            if ( value>100) {
              isValidObj.msg = 'Contingent Beneficiary cannot exceed 100%.';
              isValidObj.state = false;
              return isValidObj;
            }
          }

          if (key === 'Primary_Routing_Number') {
            this.flowManager.isAllyRoutingError = false;
            if (this._inBlacklist(value)) {
              isValidObj.msg = 'This routing number is not accepted for setting up your profile. Please verify with your bank the valid FedACH routing number for your bank account.';
              isValidObj.state = false;
              return isValidObj;
            }

            if (!this._isValidRounting(value)) {
              isValidObj.msg = 'Please enter a valid ABA Routing Number.';
              isValidObj.state = false;
              return isValidObj;
            }

            if (this.isAllyRouting(value)) {
              this.flowManager.isAllyRoutingError = true;
              isValidObj.state = false;
              return isValidObj;
            }
          }
      }
      if (rules.maxFileSize && value) {
        isValidObj.state = value.size < rules.maxFileSize;
        if (!isValidObj.state) {
          isValidObj.msg = rules.messages.maxFileSize;
          return isValidObj;
        }
      }

      // SSN Validation
      if (key.toLowerCase().includes('ssn')) {
        if (this._validateSsn(key.toLowerCase(), value) === false) {
          isValidObj.msg = 'Social Security number cannot match other account holders or beneficiaries.';
          isValidObj.state = false;
          return isValidObj;
        }
      }

      if (rules.depositDateRules === true) {
        // Holiday Check
        const parsedDate = moment(value, 'MM/DD/YYYY');
        if (this.timeService.checkDate(parsedDate)) {
          isValidObj.msg = 'Date cannot be on a holiday.';
          isValidObj.state = false;
          return isValidObj;
        }

        /// Past date check
        if (moment().subtract(1, 'days').isAfter(parsedDate)) {
          isValidObj.msg = 'Date cannot be in the past.';
          isValidObj.state = false;
          return isValidObj;
        }

        // Weekend
        if (this.timeService.isWeekend(parsedDate)) {
          isValidObj.msg = 'Date cannot be on a weekend.';
          isValidObj.state = false;
          return isValidObj;
        }

        // Within a month check
        let diffMonths = parsedDate.diff(moment(), 'months');
        if (diffMonths > 0) {
          isValidObj.msg = 'Date must be less than a month away.';
          isValidObj.state = false;
          return isValidObj;
        }

        // Transfer 2:55 PM check
        const depositDate = moment(this.timeService.getDepositDate(this.flowManager.isOneAllyBank), 'MM/DD/YYYY HH:MM:SST');

        if (parsedDate.isBefore(depositDate, 'day')) {
          isValidObj.msg = this.flowManager.isOneAllyBank === true
            ? 'Transfers after 3:55 PM EST can\'t be submitted until the next day.'
            : 'Transfers after 2:55 PM EST can\'t be submitted until the next day.';
          isValidObj.state = false;
          return isValidObj;
        }

        // IRA Contribution Deposit Date/Tax Date check
        if (this.flowManager.isIra) {
          const selectedYear = this.appActions.getData('DepositFunds.contributionYear');
          const taxEndDate = this.flowManager.config.ira.currentTaxEndDate;
          const priorYear = taxEndDate.split('/')[2] - 1;

          if (selectedYear === priorYear) {
            const taxDate = moment(taxEndDate);

            if (moment(value).isAfter(taxDate)) {
              isValidObj.msg = 'Select a contribution date that falls before last year\'s Tax Day.';
              isValidObj.state = false;
              return isValidObj;
            }
          }
        }
      }

      if (rules.depositAmountRules === true) {
        // Non IRA
        const appType = this.appActions.getData('appType');

        if (!this.flowManager.isIra) {
          let maxContribution = 30000; // ACH general max amount
          // tka ACH max amount
          if (appType === 'tka') {
            maxContribution = 150000;
          }
          // ALLY non-IRA contribution max amount
          if (this.flowManager.isOneAllyBank) {
            maxContribution = 250000;
          }
          const strContribution = maxContribution.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          if (value > maxContribution) {
            isValidObj.msg = `The maximum daily amount that can be transferred via ACH is $${strContribution}${appType === 'tka' ? ' for advisors.' : '.'}`
            if (this.flowManager.isOneAllyBank) {
              isValidObj.msg = isValidObj.msg.replace('via ACH', 'between Ally accounts');
            }
            isValidObj.state = false;
            return isValidObj;
          }
        } else {
          const contributionYear = this.appActions.getData('DepositFunds.contributionYear');
          const dob = this.appActions.getData('PersonalInformation.dob', '11/22/1988'); // Default for testing
          const age = moment().diff(moment(dob, 'MM/DD/YYYY'), 'years');
          // check for prior and current year ira contr limit
          const ira = this.flowManager.config.ira;
          const contIraAmt = JSON.parse(ira.taxYearAndAmount);
          const taxYear = ira.currentTaxEndDate.split('/')[2];
          let maxContribution;

          if (contributionYear === taxYear) {
            maxContribution = age <= 50 ? contIraAmt[taxYear].underAgeLimit : contIraAmt[taxYear].meetsAgeLimit;
          } else {
            maxContribution = age <= 50 ? contIraAmt[taxYear - 1].underAgeLimit : contIraAmt[taxYear - 1].meetsAgeLimit;
          }
          const strContribution = maxContribution.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          if (value > maxContribution) {
            isValidObj.msg = `Your transfer amount can’t exceed our daily limit of $${strContribution}. Keep in mind, you are responsible for tracking your contributions to make sure you stay within your annual IRA contribution limit.`;
            isValidObj.state = false;
            return isValidObj;
          }
        }
        if (appType === 'tka' && key === 'deposit_amount') {
          if (value < 100) {
            isValidObj.msg = 'The minimum deposit amount for an Ally Robo Portfolio is $100.00.';
            isValidObj.state = false;
            return isValidObj;
          }
        }
      }

      if (rules.patternSpecial !== undefined){
        if(eval(rules.patternSpecial)) {
          isValidObj.msg = rules.messages.patternSpecial;
          isValidObj.state = false;
        }
      }

      // Profanity filtering
      if (rules.patternBadWords) {
        const isValid = this.checkBadWords(value, rules.isNameField);
        if (!isValid) {
          isValidObj.state = false;
          isValidObj.msg = rules.messages.patternBadWords;
        }
      }

      if (rules.reduxEquals !== undefined) {
        const reduxValue = this.appActions.getData(rules.reduxEquals, '');
        if (reduxValue != value) {
          isValidObj.state = false;
          isValidObj.msg = rules.messages.reduxEquals;
        }
      }

      if (rules.minValue !== undefined) {
        if (value < rules.minValue) {
          isValidObj.msg = rules.messages.minValue;
          isValidObj.state = false;
        }
      }

      if (rules.maxValue !== undefined) {
        if (value > rules.maxValue) {
          isValidObj.msg = rules.messages.maxValue;
          isValidObj.state = false;
        }
      }

      if (rules.minAge !== undefined) {
        let ageByYears = moment().diff(moment(value,'MM/DD/YYYY'), 'years');
        if (ageByYears < rules.minAge) {
            isValidObj.msg = rules.messages.minAge;
            isValidObj.state = false;
            return isValidObj;
        }
      }

      if (rules.boolean !== undefined) {
          isValidObj.state = value === rules.boolean;
          isValidObj.msg = rules.messages.boolean;
          return isValidObj;
      }

      if (rules.maxAge !== undefined) {
        let standardAge = moment(value,'MM/DD/YYYY').add(rules.maxAge, 'year');
        if ((key === 'dobCustodial' || key === 'beneficiary.dob' || key === 'Primary_Beneficiary_Dob' || key === 'Contingent_Beneficiary_Dob' ||
          key === 'Joint_Personal_Dob') && !(moment() > moment(value,'MM/DD/YYYY'))) {
          isValidObj.msg = rules.messages.minAge;
          isValidObj.state = false;
          return isValidObj;
        }

        if (moment()>=standardAge) {
          isValidObj.msg = rules.messages.maxAge;
          isValidObj.state = false;
          return isValidObj;
        }
      }

      if (rules.max !== undefined) {
        if (value.length > rules.max) {
            isValidObj.msg = rules.messages.max;
            isValidObj.state = false;
            return isValidObj;
        }
      }

      if (rules.min !== undefined) {
        if (value.length < rules.min) {
            isValidObj.msg = rules.messages.min;
            isValidObj.state = false;
            return isValidObj;
        }
      }

      if (rules.specificLength !== undefined) {
        if (rules.specificLength.indexOf(value.length) < 0) {
          isValidObj.msg = rules.messages.specificLength;
          isValidObj.state = false;
          return isValidObj;
        }
      }

      // Special case that sucks to have in here =(
      if (key === 'tradingLevels') {
        const applyOptions = this.appActions.getData('GoalInformation.applyForOption', false);
        if (applyOptions === false) {
          isValidObj.state = true;
          return isValidObj;
        }
      }

      // DTC Number .NET validation
      if (key === 'brokerDTCNumber') {
        const validDTC = this.flowManager.isValidDTC;
        if (validDTC === false && isValidObj.state === true) {
          isValidObj.state = false;
          isValidObj.msg = rules.messages.invalidDTC;
          return isValidObj;
        }
      }

      if (rules.enum !== undefined) {

        let enumValid = false;
        switch(rules.enum) {
          case 'tradingLevels':
            enumValid = (tradingLevels.indexOf(value) <= -1) ? false : true;
            break;
          case 'accountType':
            enumValid = (AccountType.indexOf(value) <= -1) ? false : true;
            break;
          case 'wheel':
            enumValid = (Wheel.indexOf(value) <= -1) ? false : true;
            break;
          case 'address.state':
            enumValid = employedCountry !== 'US' ? true : this.selectOptions.isValidOption('state', value);
            const dob = this.appActions.getData('PersonalInformation.dob');
            const ageByYears = moment().diff(moment(dob,'MM/DD/YYYY'), 'years');
            if (enumValid && value === 'Alabama' || value === 'Nebraska') {
              if (ageByYears < 19) {
                enumValid = false;
                rules.messages.require = 'You must be 19 years old to open account in Alabama and Nebraska.';
              }
            }
            if (enumValid && value === 'Mississippi') {
              if (ageByYears < 21) {
                enumValid = false;
                rules.messages.require = 'You must be 21 years old to open account in Mississippi.';
              }
            }
            break;
          case 'annualIncome':
          case 'netWorth':
          case 'liquidNetWorth':
            enumValid = true;
            break;
          case 'citizenship':
            enumValid = this.selectOptions.isValidOption('country', value);
            break;
          case 'residency':
          case 'minorResidency':
            enumValid = typeof value === 'boolean';
            break;
          case 'maritalStatus':
            enumValid = (MaritalStatus.indexOf(value) <= -1) ? false : true;
            break;
          case 'Mailing_Address_State':
            enumValid = this.selectOptions.isValidOption('state', value);
            break;
          case 'taxBracket':
            enumValid = (TaxBracket.indexOf(value) <= -1) ? false : true;
            break;
          case 'stockYears':
          case 'stockAnnualTrades':
          case 'stockAverageTradeSize':
          case 'optionYears':
          case 'optionAnnualTrades':
          case 'optionAverageTradeSize':
            enumValid = this.selectOptions.isValidOption(rules.enum, value);
            break;
          case 'employmentStatus':
            enumValid = (EmploymentStatus.indexOf(value) <= -1) ? false : true;
            break;
          case 'natureOfBusiness':
            enumValid = (NatureOfBusiness.indexOf(value) <= -1) ? false : true;
            break;
          case 'position':
            enumValid = (Position.indexOf(value) <= -1) ? false : true;
            break;
          case 'securityQuestion':
            enumValid = (SecurityQuestion.indexOf(value) <= -1) ? false : true;
            break;
          case 'risk_tolerance':
            enumValid = (RiskTolerance.indexOf(value) <= -1) ? false : true;
            break;
          case 'liquidity_needs':
            enumValid = this.selectOptions.isValidOption('liquidityNeeds', value);
            break;
          case 'time_horizon':
            enumValid = this.selectOptions.isValidOption('timeHorizon', value);
            break;
          case 'relationship':
            enumValid = this.selectOptions.isValidOption('relationship', value);
            break;
          case 'accountTypeFunding':
            enumValid = (AccountTypeFunding.indexOf(value) <= -1) ? false : true;
            break;
          case 'bankAccountType':
            enumValid = (BankAccountTypeFunding.indexOf(value) <= -1) ? false : true;
            break;
          case 'goal':
            enumValid = (value !== null && Goal[value] !== null) ? true : false;
            break;
          case 'retirement':
            enumValid = (value !== null && Retirement[value] !== null) ? true : false;
            break;
          case 'riskTolerance':
            enumValid = (value !== null && TKARiskTolerance[value] !== null) ? true : false;
            break;
          case 'strategyType':
            enumValid = (value !== null && StrategyType[value] !== null) ? true : false;
            break;
          case 'investmentObjective':
            enumValid = value !== null;
        }
        if (rules.enum === 'accountType') {
          if (value === 'ira') {
            isValidObj.state = enumValid;
            isValidObj.msg = '';
            return isValidObj;
          }
        }

        if (rules.enum === 'isExperienced'){
          isValidObj.state = true;
          return isValidObj;
        }

        if (enumValid === false) {
          isValidObj.state = false;
          isValidObj.msg = rules.messages.require;
          return isValidObj;
        }
      }

      // Use this rule if you need an api call to validate an input
      // or store if the input in valid in redux
      if (rules.reduxValue && value !== '') {
        if (this.appActions.getData(rules.reduxValue, false)) {
          isValidObj.state = false;
          isValidObj.msg = rules.messages.reduxValue;
          this.appActions.setData(rules.reduxValue, false);
        }
      }
      return isValidObj;

    } catch (e) {
      // return e;
      // console.log('Error', e);
    }
  }
}
